import { NgModule } from '@angular/core';
import { CapitalizePipe} from './capitalize/capitalize';
import { OrderByPipe } from './order-by/order-by';
import { KeysPipe } from './keys-pipe';
@NgModule({
	declarations: [CapitalizePipe,
    OrderByPipe, KeysPipe],
	imports: [],
	exports: [CapitalizePipe,
    OrderByPipe, KeysPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts